import { useTranslation } from 'react-i18next'
import { saveLocalState } from '@/utils/storage'
import { Lang } from '@/types/utility.types'

export default function useChangeLanguage() {
  const { i18n } = useTranslation()

  return (lng: Lang) => {
    i18n.changeLanguage(lng)
    saveLocalState('lang', lng)
  }
}
